<div class="flex column center padding">
	@if (mediaKind === 'image') {
		<img class="media-content" [src]="src" alt="Media preview" />
	} @else if (mediaKind === 'video') {
		<video class="media-content" [src]="src" controls></video>
	} @else {
		<div class="card padding flex column center">
			<span class="bold">Media not supported</span>
		</div>
	}
</div>
